import CustomerCriteria from '../Criteria/CustomerCriteria'
import apiClient from '../Util/ApiClient'

export class SupplierApi {
	static getAllConnections(query: string) {
		return apiClient.get('/admin/connections/autocomplete', {
			params: { sort: 'createdAt:desc', query },
		})
	}
	static getProfiles(query: string) {
		return apiClient.get('/admin/profiles/autocomplete', {
			params: { sort: 'createdAt:desc', query },
		})
	}
	static customerFilter = (filter: CustomerCriteria) => {
		let limit = filter && filter.size ? filter.size : 25
		let offset = filter && filter.page ? filter.page * limit : 0
		return apiClient.get('/admin/customers', { params: { ...filter, offset, limit, sort: 'createdAt:desc' } })
	}
	static customerDetail = (username?: string) => {
		return apiClient.get(`/admin/customers/${username}`)
	}
	static getConnectionByCustomer = (username: string, provider: string) => {
		return apiClient.get(`/admin/customers/${username}/connections`, {params: {provider}})
	}
	static getDefaultAddress = (username: string) => {
		return apiClient.get(`/admin/addresses/${username}`)
	}
	static getBalanceOfConnection = (username: string, id: string) => {
		return apiClient.get(`/admin/customers/${username}/connections/${id}`)
	}
	static getListAccount = (): Promise<any> => {
		return apiClient
			.get(`connections`, {params:{sort:'createdAt:desc'}})
	};
	
}
